import React, { useState } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'
import PrivateRoute from '../components/PrivateRoute'
import { history } from '../utils/history'
import Login from '../screens/Login'
// import PickingLoad from '../screens/PickingLoad'
import PickingEstate from '../screens/PickingEstate'
import PickingTypes from '../screens/PickingTypes'
import ManifestResend from '../screens/ManifestResend'
import ManifestHistory from '../screens/ManifestHistory'
import ManifestCompanies from '../screens/ManifestCompanies'
import ManifestResendDetail from '../screens/ManifestResendDetail'
import ManifestHistoryDetail from '../screens/ManifestHistoryDetail'
import PickingEstateDetail from '../screens/PickingEstateDetail'
import { API_KEYS } from '../api/constants'
import Loading from '../components/shared/Loading'
import PickingLocations from '../screens/PickingLocation'
// import PickingReassignment from '../screens/PickingReassignment'
// import PickingReassignmentDetail from '../screens/PickingReassignmentDetail'


import useRenewToken from '../hooks/useRenewToken'
import { sessionError } from '../utils/sessionError'
import AnotherSessionModal from '../components/shared/AnotherSessionModal'


const API_KEY = API_KEYS.API_KEY_PRD;

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    config.headers['x-api-key'] = API_KEY;
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
)

const Routes = () => {
  const [isOpen, setIsOpen] = useState(false)
  const user = useSelector(state => state.authReducer.user)
  const loading = useSelector(state => state.loadingReducer)

  const { loading: renewLoading } = useRenewToken({
    startRenew: user,
    onError: (err) => {
      if (sessionError(err)) {
        console.log('DOBLE_SESSION')
        setIsOpen(true)
      }
    }
  })

  if (renewLoading) return <Loading visible />

  return (
    <>
      <AnotherSessionModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <Loading visible={loading || renewLoading} />
      <Router history={history}>
        <Switch>
          <Route exact path="/login" render={() => {
            return user ? <Redirect to='/reporte-estados' /> : <Login />
          }} />
          {/* <PrivateRoute exact path="/carga" component={PickingLoad} /> */}
          <PrivateRoute exact path="/reporte-estados" component={PickingEstate} />
          <PrivateRoute exact path="/reporte-estados/:id" component={PickingEstateDetail} />
          <PrivateRoute exact path="/ubicacion-items" component={PickingLocations} />
          {/* <PrivateRoute exact path="/reasignacion" component={PickingReassignment} />
          <PrivateRoute exact path="/reasignacion/:id" component={PickingReassignmentDetail} /> */}
          <PrivateRoute exact path="/tipos-despacho" component={PickingTypes} />
          <PrivateRoute exact path="/reenvio-manifiestos" component={ManifestResend} />
          <PrivateRoute exact path="/reenvio-manifiestos/:id" component={ManifestResendDetail} />
          <PrivateRoute exact path="/historial-reportes" component={ManifestHistory} />
          <PrivateRoute exact path="/historial-reportes/:id" component={ManifestHistoryDetail} />
          <PrivateRoute exact path="/empresas" component={ManifestCompanies} />
          <Redirect from="*" to="/reporte-estados" />
        </Switch>
      </Router>
    </>
  )

}

export default Routes
